import axios from "axios";
import router from "./router/index.js";
import cookie from "./utils/cookie.js";
import config from "./config.json";
import vue from "./utils/bus.js";
import UUIDUtil from "./utils/uuidTool.js";

// 请求初始化配置
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";

// axios.defaults.baseURL = config.api_url + "request/";
// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {
    // console.log('发送请求：', config)
    // 在发送请求之前做些什么
    let params = config.data;
    let token = cookie.getCookie("platformsessionId");
    if (token != null) {
      config.headers.Authorization = token;
    }
    config.data = {
      content: params,
      accessToken: token
    };
    // 增加处理requestid，用来做重复提交处理
    if (params && params.noduplicateable) {
      let requestId = cookie.getCookie("requestId");
      if (requestId == null || requestId == "") {
        requestId = UUIDUtil.generateuuid();
        cookie.setCookie("requestId", requestId);
      }
      config.data.requestId = requestId;
    }
    return config;
  },
  function(error) {
    // console.log('请求错误：', error)
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    // console.log('响应：', response)
    // 对响应数据做点什么
    if (response.data.code == 400) {
      cookie.delCookie("platformsessionId");
      router.replace({
        path: "/",
        redirect: "/"
      });
      return false;
    }
    cookie.setCookie("requestId", "");
    if (response.data.code == 401) {
      if (
        response.data.errorCode &&
        response.data.errorCode != null &&
        (response.data.errorCode == "Worker.ActionSecurityToken.Required" ||
          response.data.errorCode == "Worker.ActionSecurityToken.Expire")
      ) {
        cookie.delCookie("platformsessionId");
        router.replace({
          path: "/",
          redirect: "/"
        });
        return false;
      } else {
        vue.$message.error(response.data.message);
        let res = response.data.content;
        return res;
      }
    } else if (response.data.errorCode == -100) {
      router.replace({
        path: "/",
        redirect: "/"
      });
      return false;
    }
    let res = response.data.content;
    return res;
  },
  function(error) {
    console.log("响应错误：", error);
    // 对响应错误做点什么
    cookie.setCookie("requestId", "");
    if (error.response) {
      switch (error.response.status) {
        case 406:
          console.log("忽略重复提交");
          return false;
        // case 404:
        //   router.replace({
        //     path: "/",
        //     redirect: '/home'
        //   })
      }
    }
    return error;
  }
);
export default axios;
Promise.reject;



// WEBPACK FOOTER //
// ./src/http.js